import React from 'react'
import { UploadOutlined } from '@ant-design/icons'
import { Button, message, Upload } from 'antd'
import { modalError } from '@/utils/modalUtils'
import { formatMessageNew } from '@/utils/common'

const UploadBtn = props => {
  const { btnName, accept, callBack, fileSize, fileSizeErrTip, ...resProps } = props
  const beforeUploadHandler = file => {
    // fileSize单位kb
    if (fileSize) {
      const isLtFileSize = file.size / 1024 >= fileSize
      if (isLtFileSize) {
        modalError({
          content: fileSizeErrTip
        })
        return false
      }
    }
    if (accept) {
      let fileArr = file.name.split('.')
      let extensionName = fileArr[fileArr.length - 1]
      if (accept.indexOf(extensionName) === -1) {
        file.status = 'error'
        modalError({
          content: formatMessageNew('languageObj.configuration.fileExtentionError') + accept
        })
        return false
      }
    } else {
      if (file.name.indexOf('.xlsx') === -1 && file.name.indexOf('.xls') === -1) {
        file.status = 'error'
        modalError({
          content: formatMessageNew('languageObj.configuration.fileExtentionError') + 'xlsx or xls'
        })
        return false
      }
    }
  }
  const uploadProps = {
    name: 'file',
    showUploadList: false,
    beforeUpload: beforeUploadHandler,
    accept: accept || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
    onChange(info) {
      if (info.file.status === 'error') {
        const errMsg = info.file.error ? info.file.error.error_message : null
        if (!errMsg) {
          return
        }
        message.error(errMsg)
      }

      if (info.file.status === 'done') {
        message.success(formatMessageNew('languageObj.commonLocale.success'))
        // 查询
        callBack && callBack()
      }
    }
  }

  const uploadAarrOrderRequest = options => {
    var form = new FormData()
    form.append('file', options.file)
    props.uploadAjax && props.uploadAjax(form)
  }
  const uploadRequest = {
    customRequest: uploadAarrOrderRequest
  }

  return (
    <Upload {...uploadProps} {...resProps} {...uploadRequest}>
      <Button type="primary" icon={<UploadOutlined />}>
        {btnName || 'Upload'}
      </Button>
    </Upload>
  )
}

export default UploadBtn
